export const KEYCODE_ESCAPE = 27;



// WEBPACK FOOTER //
// ./vendor/kunstmaan/cookie-bundle/Resources/ui/js/config/keycodes.config.js